import { motion } from 'framer-motion';
import { Mail } from 'lucide-react';
import { STEPS, COMPANY } from '../data/site';
import Reveal, { ChapterLabel, EASE } from './Reveal';

export default function Process() {
  return (
    <section id="ablauf" data-testid="process-section" className="bg-slate-50 py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <ChapterLabel index="05" title="Ablauf" />
        <div className="mt-8 flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <Reveal delay={0.1}>
            <h2 className="max-w-2xl font-display text-3xl font-extrabold tracking-tight text-navy sm:text-4xl lg:text-5xl">
              In vier Schritten zum <span className="text-brand">entspannten Umzug</span>.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-sm leading-relaxed text-slate-500 md:text-base">
              Klar strukturiert von der ersten Anfrage bis zur besenreinen Übergabe.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.step}
              data-testid={`process-step-${i + 1}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: EASE }}
              className="group relative rounded-3xl border border-slate-200 bg-white p-7 transition-all duration-500 hover:-translate-y-2 hover:border-brand/40 hover:shadow-xl hover:shadow-brand/10"
            >
              <span className="fm-outline-num font-display text-6xl font-extrabold transition-all duration-500 group-hover:text-brand">
                {s.step}
              </span>
              <h3 className="mt-6 font-display text-lg font-bold text-navy">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-500">{s.desc}</p>
              {i < STEPS.length - 1 && (
                <span className="absolute -right-4 top-1/2 hidden h-px w-8 bg-slate-300 lg:block" />
              )}
            </motion.div>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-14">
          <div className="flex flex-col items-center justify-between gap-6 rounded-3xl bg-navy p-8 sm:p-10 md:flex-row" data-testid="process-cta">
            <div>
              <p className="font-display text-2xl font-extrabold text-white sm:text-3xl">
                Lieber direkt persönlich klären?
              </p>
              <p className="mt-2 text-sm text-slate-400">
                Schreiben Sie uns – wir beraten Sie unverbindlich. {COMPANY.hours}
              </p>
            </div>
            <a
              href={`mailto:${COMPANY.email}`}
              data-testid="process-cta-mail"
              className="inline-flex shrink-0 items-center gap-3 rounded-full bg-brand px-8 py-4 font-display text-base font-bold text-white shadow-xl shadow-brand/40 transition-all duration-300 hover:-translate-y-0.5 hover:bg-brand-hover"
            >
              <Mail className="h-5 w-5" /> {COMPANY.email}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
